import WordPuzzlePage from "@components/Modules/Kuiz/WordPuzzle";
import { QuizCardProps } from "@typings/QuickNews";
import { ReactElement } from "react";

type QNQuizCardProps = {
  item?: QuizCardProps;
};

export function QnQuizCard({ item }: QNQuizCardProps): ReactElement {
  return (
    <>
      {item != undefined && (
        <div className="qn-quiz w-full h-full bg-bg-primary" key={item.id}>
          <WordPuzzlePage mobileView={true} isQuickNews={true} />
        </div>
      )}
    </>
  );
}
